// Top Level BottomHelpButton.vue

// Top Level Files
import Assets from '../docs-top-level/Assets.mdx';
import Channels from '../docs-top-level/Channels.mdx';
import Configure from '../docs-top-level/Configure.mdx';
import OnAir from '../docs-top-level/OnAir.mdx';
import Templates from '../docs-top-level/Templates.mdx';
import Presets from '../docs-top-level/Presets.mdx';

const topLevel = {
  Assets,
  Channels,
  Configure,
  OnAir,
  Templates,
  Presets,
};

// Configure
import AppsConfigure from '../docs-component-level/AppsConfigure.mdx';
import AssetsConfig from '../docs-component-level/AssetsConfig.mdx';
import CanvasConfig from '../docs-component-level/CanvasConfig.mdx';
import DefaultQueueConditionsConfig from '../docs-component-level/DefaultQueueConditionsConfig.mdx';
import NetworkConfig from '../docs-component-level/NetworkConfig.mdx';
import RolesConfig from '../docs-component-level/RolesConfig.mdx';
import TaggingConfig from '../docs-component-level/TaggingConfig.mdx';
import UserConfigure from '../docs-component-level/UserConfigure.mdx';
import VentuzConfig from '../docs-component-level/VentuzConfig.mdx';
import YourCanvasPro from '../docs-component-level/YourCanvasPro.mdx';
import AudioConfigure from '../docs-component-level/AudioConfigure.mdx';
import ConnectionsConfig from '../docs-component-level/ConnectionsConfig.mdx';
const configureComponents = {
  AppsConfigure,
  AssetsConfig,
  CanvasConfig,
  DefaultQueueConditionsConfig,
  NetworkConfig,
  RolesConfig,
  TaggingConfig,
  UserConfigure,
  VentuzConfig,
  YourCanvasPro,
  AudioConfigure,
  ConnectionsConfig,
};

// Configure Sub Components
import AddOrEditTag from '../docs-component-level/AddOrEditTag.mdx';
import AddOrEditLocation from '../docs-component-level/AddOrEditLocation.mdx';
import EditUserModal from '../docs-component-level/EditUserModal.mdx';
import CreateEditRole from '../docs-component-level/CreateEditRole.mdx';

const configureSubComponents = {
  AddOrEditTag,
  AddOrEditLocation,
  EditUserModal,
  CreateEditRole,
};

// Assets Sub Components

import NewAsset from '../docs-component-level/NewAsset.mdx';
import SelectTag from '../docs-component-level/SelectTag.mdx';
import AssetDialog from '../docs-component-level/AssetDialog.mdx';

const assetsSubComponents = {
  NewAsset,
  SelectTag,
  AssetDialog,
};

// Assets Sub Components
import EditTemplateModal from '../docs-component-level/EditTemplateModal.mdx';

const templatesSubComponents = { EditTemplateModal };

// Channels Sub Components
import CreateChannel from '../docs-component-level/CreateChannel.mdx';
import AssignChannel from '../docs-component-level/AssignChannel.mdx';

const channelsSubComponents = { CreateChannel, AssignChannel };

// OnAir Sub Components
import EditChannel from '../docs-component-level/EditChannel.mdx';
import CanvasOptions from '../docs-component-level/CanvasOptions.mdx';
import CreatePanelModal from '../docs-component-level/CreatePanelModal.mdx';

const onAirSubComponents = { EditChannel, CanvasOptions, CreatePanelModal };

// Queue Sub Components
import QueueDeck from '../docs-component-level/QueueDeck.mdx';
import AddQueue from '../docs-component-level/AddQueue.mdx';
import EditQueueModal from '../docs-component-level/EditQueueModal.mdx';
import CreateScene from '../docs-component-level/CreateScene.mdx';
import EditSceneModal from '../docs-component-level/EditSceneModal.mdx';

const queueSubComponents = {
  QueueDeck,
  AddQueue,
  EditQueueModal,
  CreateScene,
  EditSceneModal,
};

// Upload Sub Components

import ResolveConflicts from '../docs-component-level/ResolveConflicts.mdx';
const uploadSubComponents = {
  ResolveConflicts,
};

export const helpComponents = {
  ...topLevel,
  ...configureComponents,
  ...configureSubComponents,
  ...assetsSubComponents,
  ...templatesSubComponents,
  ...channelsSubComponents,
  ...onAirSubComponents,
  ...queueSubComponents,
  ...uploadSubComponents,
};
